module.exports = __webpack_public_path__ + "img/logo.3a640e15.svg";